import { useState } from "react";
import { AlertTriangle, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../store/AuthContext";
import { OnboardingShell } from "./AuthPage";
import { CheckoutPanel } from "../components/onboarding/CheckoutPanel";
import { firstNameOf } from "../components/workspace/WelcomeIntro";

// The subscription stopped paying (card declined, month ended, cancelled): nothing in the workspace is usable until a payment goes through.
export default function RenewalGate({ demo = false }) {
  const { user, refresh, signOut, setPreviewAs } = useAuth();
  const [plan, setPlan] = useState(user.plan === "yearly" || user.plan_intent === "yearly" ? "yearly" : "monthly");
  const reason = user.plan_state === "past_due" ? "Your automatic payment didn't go through." : user.plan_state === "canceled" ? "Your subscription was cancelled." : "Your Xpattern subscription has ended.";
  const onPaid = async () => { await refresh(); toast.success(`You're back on Xpattern ${plan === "yearly" ? "Yearly" : "Monthly"} — happy cutting!`, { duration: 8000 }); };
  return (
    <OnboardingShell wide title="Action needed — reactivate Xpattern" icon={AlertTriangle} iconClass="text-[#e5484d]" noLogo testId="renewal-gate"
      subtitle={`Hi ${firstNameOf(user)}. ${reason} Xpattern is paused until billing is updated — add a card below and you're cutting again in a minute.`}>
      <CheckoutPanel plan={plan} setPlan={setPlan} onPaid={onPaid} demo={demo} email={user.email} />
      <button data-testid="renewal-gate-signout" onClick={demo ? () => setPreviewAs("first_launch") : signOut} className="mt-4 flex w-full items-center justify-center gap-1 text-[11px] text-[#6b7079] hover:text-[#e8e9ec]"><LogOut className="h-3 w-3" /> Not you? Sign out</button>
    </OnboardingShell>
  );
}
